// SorteioPage.jsx
import React, { useState } from "react";
import { api } from '../../services/api';
import { useParams } from "react-router-dom";
import { Container, Typography, Button, Box, Paper } from "@mui/material";

export default function SortionSubscriber() {
  const [sorteado, setSorteado] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [animando, setAnimando] = useState(true);
  const [placeholderId, setPlaceholderId] = useState('...');
  const [placeholderNome, setPlaceholderNome] = useState('...');
  const { eventId } = useParams();

  async function getSort() {
    setSorteado(null)
    setCarregando(true)
    let animInterval;
    const gerarNomeFalso = () => {
      const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

      const gerarPalavra = (tamanho) => {
        let palavra = '';
        for (let i = 0; i < tamanho; i++) {
          palavra += letras.charAt(Math.floor(Math.random() * letras.length));
        }
        // Capitaliza a primeira letra
        return palavra.charAt(0).toUpperCase() + palavra.slice(1);
      };

      const nome = gerarPalavra(Math.floor(Math.random() * 3) + 4);     // 4 a 6 letras
      const sobrenome = gerarPalavra(Math.floor(Math.random() * 4) + 5); // 5 a 8 letras

      return `${nome} ${sobrenome}`;
    };
    const iniciarAnimacao = async () => {
      setAnimando(true);
      animInterval = setInterval(() => {
        const fakeId = Math.floor(Math.random() * 100000);
        const fakeName = gerarNomeFalso()
        setPlaceholderNome(fakeName);
        setPlaceholderId(fakeId);
      }, 100); // muda a cada 100ms
    };
    const buscarResultadoReal = async () => {
      try {
        const { status, data } = await api.get(`order/sorteio/${eventId}`);
        if (status !== 200) throw new Error("Erro ao buscar sorteado");

        // simula tempo de "suspense"
        setTimeout(() => {
          clearInterval(animInterval);
          setSorteado(data);
          setAnimando(false);
          setCarregando(false);
        }, 3000); // tempo total da animação
      } catch (err) {
        console.error(err);
        clearInterval(animInterval);
        setCarregando(false);
        setAnimando(false);
        setSorteado({ id: '--', nome: '---------' });
      }
    };
    await iniciarAnimacao()
    await buscarResultadoReal()

  }


  return (
    <Container maxWidth="lg" sx={{ mt: 5, textAlign: "center" }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Sorteio em Andamento
        </Typography>

        {carregando && (
          <>
            <Typography variant="h6">Código:</Typography>
            <Typography variant="h3" color="green">
              {placeholderId}
            </Typography>
            <Box mt={2}>
              <Typography variant="h6">Nome:</Typography>
              <Typography variant="h4">{placeholderNome}</Typography>
            </Box>
          </>
        )}

        {!carregando && sorteado && (
          <>
            <Typography variant="h6">Código:</Typography>
            <Typography variant="h2" color="green">{sorteado.id}</Typography>
            <Box mt={2}>
              <Typography variant="h3">Nome:</Typography>
              <Typography variant="h2" color="green">{sorteado.nome}</Typography>
              <Typography variant="h3">Cidade:</Typography>
              <Typography variant="h2" color="green">{sorteado.cidade} / {sorteado.estado}</Typography>
            </Box>
          </>
        )}
        <Button onClick={getSort}>Sortear novo Inscrito</Button>
      </Paper>
    </Container>
  );
};

